import {
  GoogleSearchMethods,
  useSuggestions,
} from '@awaze/mfe-common.api.places-api'
import { PlacesSuggestions } from '../SearchForm.types'
import { Assert } from 'src/utils/assert'
import { formatAutocompleteSubtitle } from '../SearchForm.helper'

export const usePlacesSuggestions = (
  googleSearchMethod: GoogleSearchMethods,
): PlacesSuggestions => {
  const getSuggestions = useSuggestions()
  return async (searchTerm: string) => {
    try {
      return (await getSuggestions(searchTerm, 100, googleSearchMethod)).map(
        (location) => ({
          ...location,
          subtitle: formatAutocompleteSubtitle(location),
          link: '',
        }),
      )
    } catch (e) {
      Assert.error(e)
      // eslint-disable-next-line no-console
      console.log('Error while calling places', e.message)
      return []
    }
  }
}
